export default "__VITE_ASSET__CpNvMnHc__"